export default __webpack_public_path__ + "static/media/animation.700d1bf5.png";